import { useContext } from 'react';

import {
  Box,
  alpha,
  lighten,
  IconButton,
  Tooltip,
  styled,
  useTheme
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

import HeaderUserbox from './Userbox';

interface HeaderWrapperProps {
  collapsed?: boolean;
}

const HeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed'
})<HeaderWrapperProps>(
  ({ theme, collapsed }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.98)};
        backdrop-filter: blur(8px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid ${alpha(theme.colors.alpha.trueWhite[100], 0.1)};
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${collapsed ? theme.sidebar.collapsedWidth : theme.sidebar.width};
            width: auto;
            transition: left 0.3s ease;
        }
`
);


function Header() {
  const { sidebarToggle, toggleSidebar, sidebarCollapsed } = useContext(SidebarContext);
  const theme = useTheme();

  return (
    <HeaderWrapper
      collapsed={sidebarCollapsed}
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.1
              )}`
            : `0px 1px 3px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          component="span"
          sx={{
            display: { lg: 'none', xs: 'inline-flex' }
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButton
              color="inherit"
              onClick={toggleSidebar}
              sx={{
                color: theme.colors.alpha.trueWhite[70],
                '&:hover': {
                  background: alpha(theme.colors.alpha.trueWhite[100], 0.1)
                }
              }}
            >
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box display="flex" alignItems="center">
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
